module.exports = __webpack_public_path__ + "static/media/IMG_2215.f6ddc682.JPG";